export default [
  { label: 'フリーサイト', value: 'facility_freesite' },
  { label: '区画サイト', value: 'facility_sectionsite' },
  { label: 'AC電源サイト', value: 'facility_acsite' },
  { label: 'グランピング', value: 'facility_glamping' },
  { label: 'ソロキャン専用サイト', value: 'facility_solo' },
  { label: 'プライベートサイト（1日1組）', value: 'facility_privatesite' },
  { label: 'ロッジ・ログハウス・コテージ', value: 'facility_cottage' },
  { label: 'バンガロー・キャビン', value: 'facility_bungalow' },
  { label: 'トレーラーハウス', value: 'facility_trailerhouse' },
  { label: 'ティピー・パオ', value: 'facility_tipi' },
  { label: 'ツリーハウス', value: 'facility_treehouse' },
];
